import React from 'react';
import { faSort, faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FormCheck from "react-bootstrap/FormCheck";


const TableHead = ({ selectedItems, setSelectedItems, filteredRows,
                         columns,
                         setActivePage,
                         filters, setFilters,
                         sort, setSort,
                         itemsIds
                       }) => {


  const normalizeOptions = options => (options || []).map(opt =>
    typeof opt === "string"
      ? {label: opt, value: opt}
      : {label: opt.label ?? opt.value, value: opt.value ?? opt.label}
  );

  const buildOptions = column => {
    if (typeof column.optionsFactory === "function") {
      return normalizeOptions(column.optionsFactory({filters, filteredRows}) || []);
    }
    if (Array.isArray(column.optionsMap) && column.optionsMap.length) {
      return column.optionsMap
        .map(value => String(value).split("->").slice(0, 2).map(part => part.trim()))
        .filter(([label, value]) => label && value)
        .map(([label, value]) => ({label, value}));
    }
    return normalizeOptions(column.options);
  };


  const handleSort = (accessor) => {
    const column = columns.find(col => col.accessor === accessor);
    if (!column.sortable) {
      return;
    }
    setActivePage(1)
    setSort((prevSort) => ({
      order: prevSort.order === 'asc' && prevSort.orderBy === accessor ? 'desc' : 'asc',
      orderBy: accessor,
    }))
  }


  const handleSearch = (value, accessor) => {
    setActivePage(1);
    setFilters(prevFilters => {
      const updatedFilters = {...prevFilters};
      if (value) updatedFilters[accessor] = value;
      else delete updatedFilters[accessor];

      const column = columns.find(item => item.accessor === accessor);
      (column?.clearsFilters || []).forEach(filterAccessor => delete updatedFilters[filterAccessor]);
      return updatedFilters;
    });
  }


  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      const newSelectedItems = new Set(filteredRows.map(item => item.id));
      setSelectedItems(newSelectedItems);
    } else {
      setSelectedItems(new Set());
    }
  }



  return (
    <thead style={{backgroundColor: "#D9DFF0"}}>
    <tr className = "table-settings-header">
      <th></th>
      {columns.map((column) => {
        if (column.visible !== false) {
          const sortIcon = () => {
            if (column.accessor === sort.orderBy) {
              if (sort.order === 'asc') {
                return <FontAwesomeIcon icon={faSortUp}/>
              }
              return <FontAwesomeIcon icon={faSortDown}/>
            } else {
              return <FontAwesomeIcon icon={faSort} className={"invisible"}/>
            }
          }

          return (
            // <th key={column.accessor} onClick={() => handleSort(column.accessor)}>
            <th key={column.accessor} onClick={column.sortable ? () => handleSort(column.accessor) : undefined} className={column.sortable ? "sortable-header" : "non-sortable-header"}>
              <span>{column.label}</span>
              {column.sortable &&
                <button className="sort-button" onClick={() => {
                  handleSort(column.accessor)
                }}>{sortIcon()}</button>}
            </th>
          )
        }
      })}
    </tr>
    <tr className = {"table-settings-filters"}>
      <th key="select-all-check"><FormCheck
        type="checkbox"
        checked={selectedItems.size === filteredRows.length && filteredRows.length > 0}
        onChange={(e) => handleSelectAll(e.target.checked)}
      ></FormCheck></th>
      {columns.map((column) => {
        if (column.visible !== false) {
          return (
            <th key={`${column.accessor}-filter`}>
              {column.searchable && (
                column.type === "bool" ? (
                  <select
                    className="search_select"
                    value={filters[column.accessor] ?? ""}
                    onChange={(event) => {
                      const val = event.target.value
                      if (val !== "") handleSearch(val, column.accessor)
                      else handleSearch("", column.accessor)
                    }}
                  >
                    <option value="">Wszystko</option>
                    <option value="true">TAK</option>
                    <option value="false">NIE</option>
                  </select>
                ) : column.type === "options" ? (
                  <select
                    className="search_select"
                    value={filters[column.accessor] ?? ""}
                    onChange={(e) => {
                      const val = e.target.value
                      if (val !== "") handleSearch(val, column.accessor)
                      else handleSearch("", column.accessor)
                    }}
                  >
                    <option value="">Wszystko</option>
                    {buildOptions(column).map(option => (
                      <option key={String(option.value)} value={option.value}>{option.label}</option>
                    ))}
                  </select>
                ) : column.type === "optionsMap" ? (
                  <select
                    className="search_select"
                    value={filters[column.accessor] ?? ""}
                    onChange={(e) => handleSearch(e.target.value, column.accessor)}
                  >
                    <option value="">Wszystko</option>
                    {buildOptions(column).map(option => (
                      <option key={String(option.value)} value={option.value}>{option.label}</option>
                    ))}
                  </select>
                ) : (
                  <input
                    className="search_textbox"
                    key={`${column.accessor}-search`}
                    type="search"
                    placeholder="Szukaj"
                    value={filters[column.accessor] ?? ""}
                    onChange={(event) => handleSearch(event.target.value, column.accessor)}
                  />
                )
              )}
            </th>
          )
          // return (
          //   <th key={`${column.accessor}-filter`}>
          //     {column.searchable &&
          //       <input className={"search_textbox"}
          //         key={`${column.accessor}-search`}
          //         type="search"
          //         placeholder={`Szukaj`}// ${column.label}`}
          //         value={filters[column.accessor]}
          //         onChange={(event) => handleSearch(event.target.value, column.accessor)}
          //       />
          //     }
          //   </th>
          // )
        }
      })}
    </tr>
    </thead>
  );
};

export default TableHead;

